import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  GetVeteranVehicleModelsEntity,
  GetVeteranVehicleModelsError,
  VeteranModel,
} from "./interfaces";

import { VeteranAutoType } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/VeteranAuto";

const initialState: GetVeteranVehicleModelsEntity = {
  current: null,
  isLoading: false,
  error: null,
};

const getVeteranVehicleModelSlice = createSlice({
  name: "getVeteranVehicleModel",
  initialState,
  reducers: {
    getVeteranVehicleModelStart: (
      state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      payload: PayloadAction<{ vehicleType: VeteranAutoType }>,
    ) => {
      state.isLoading = true;
    },

    getVeteranVehicleModelSucceded: (
      state,
      { payload: { models } }: PayloadAction<{ models: VeteranModel[] }>,
    ) => {
      state.current = models;
      state.isLoading = false;
      state.error = null;
    },

    operationFailed: (
      state,
      {
        payload: { error },
      }: PayloadAction<{
        error: GetVeteranVehicleModelsError;
      }>,
    ) => {
      state.isLoading = false;
      state.error = error;
    },
  },
});

export const {
  getVeteranVehicleModelStart,
  getVeteranVehicleModelSucceded,
  operationFailed,
} = getVeteranVehicleModelSlice.actions;
export const getVeteranVehicleModel = getVeteranVehicleModelSlice.reducer;
